import { setDefaults as a } from "./index86.mjs";
var i = {
  type: "3rdParty",
  init: function(t) {
    a(t.options.react);
  }
};
export {
  i as initReactI18next
};
